import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";
//import axios from '../../../../utils/axiosConfig';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import TableOnSteroids from '../../../../../frontend/components/components/utils/TableOnSteroids';
import configureStore from '../../../../../frontend/components/store/configureStore';
import userSession from '../../../../utils/userSession';
import ComponentMap, { DEFAULT_COLUMNS } from './ParticipationComponentMap.js';

const store = configureStore();
const userId = userSession('id');

function ParticipationTableOnSteroids() {
  const { t } = useTranslation();

  return (<Container className="page" id="tables">
    <div className='home-page-content'>
      <Provider store={store}>
        <Router>
          <TableOnSteroids
            tableId="participatedOffers"
            objectsUrl={`/api/v1/influencers/users/${userId}/participated_offers`}
            objectType="userOffer"
            componentMap={ComponentMap}
            defaultColumns={DEFAULT_COLUMNS}
            title={t('influencers.common.campaigns_title')}
            hideFilters={true}
            hideSearch={true}
            styleVersion='v4'
            className='knowledge-table-example'
            influencerCampaignTable={true}
          />
        </Router>
      </Provider>
    </div>
  </Container>);
}

export default ParticipationTableOnSteroids;
